export default function setRef(_0x2f3cd0,_0x4fef2e){if(typeof _0x2f3cd0==='function')_0x2f3cd0(_0x4fef2e);else _0x2f3cd0&&(_0x2f3cd0['current']=_0x4fef2e);}